module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/Monthly Attendance/monthly-attendance-grid/monthly-attendance-grid.component.css
// module id = ./src/app/hrms/serviceregister/Monthly Attendance/monthly-attendance-grid/monthly-attendance-grid.component.css
// module chunks = main